import React, { Component } from 'react'
import Simplefooter from '../footer/simplefooter'

export default class AboutUs extends Component {
  state = {
    notShow: true
  }

  render() {
    return (
      <div className="fullHeight">
        <section id="aboutUs" className="clear">  
          <header>
            <div className="container squad">
              <h2 className='h2-custom'>Sobre Nós</h2>
            </div>

          </header>
          <article>
            <div className="squad clear">
            {this.state.notShow ? null : (
              <div 
                className="featured clear"
                style={{backgroundImage: `url(/imgs/Imagem1.png)`}}
                >
              </div> 
            )}
              <span className="textContent">
                <h3>Somos a HIT-BRA!  Prazer em te conhecer.</h3>
                <p>
                  Um grupo de professores e profissionais com compromisso firmado em disseminar o conhecimento para as pessoas, para que as mesmas consigam realizar seus sonhos profissionais através de conhecimentos específicos nas áreas de negócios, inovações e tecnologias.<br />
                   Assim possibilitamos a todos o poder de igualdade em aquisição de conhecimentos voltados para o nosso conceito primordial que denominamos de BIT (Business Innovation Technology).
                </p>

                <p>A HIT-BRA hoje é a união da solidez acadêmica e profissional das melhores mentes brilhantes de São Paulo e região, a qual a anos atuam nesse segmento de ensino e possui grande experiência e sucesso usando tecnologias e inovações nas empresas, assim como na prospecção de novos negócios, dando origem à diversas startups e até mesmo no reposicionamento positivo de grandes empresas nacionais e internacionais.</p>

                <h3>OBJETIVO</h3>
                <p>Temos um conjunto de cursos e workshops que têm como objetivo oferecer uma vasta coletânea de aprendizado em negócios, inovações e tecnologias, na qual você pode discutir, participar e enriquecer seus conhecimentos, investindo seu tempo da melhor maneira possível em sua carreira profissional e até mesmo pessoal.</p>

                <p>Nosso centro de ensino é inovador, que propõe um aprendizado extraordinariamente estruturado em tecnologias futuristas, entregando soluções incrivelmente disruptivas em produtos e serviços. Com professores especializados e certificados, e com parcerias estratégicas com as empresas Google, Oracle, Apigee, IBM e AWS.</p>

                <h3>DESAFIO</h3>
                <p>O nosso desafio é fazer você se sentir parte desse grupo de profissionais de tecnologia que querem ser melhores do que eram ontem, para isso fomos muito além das clássicas salas de aulas. Não é à toa que temos um dos melhores corpos docentes (mestres e doutores) de São Paulo e do Brasil.</p>

                <h3>PARA VOCÊ</h3>
                <p>Viemos para expandir o seu conceito de conhecimento através em um ambiente colaborativo, imersivo e interativo de aprendizagem, para você melhorar suas habilidades como profissional de negócios, de inovações e de tecnologias.<br />
                A nossa meta é focar na realidade do mercado brasileiro e na entrega de resultado com qualidade e eficiência, tomando sempre a experiência, o objetivo, os exemplos de casos de sucesso e a praticidade como base principal de nossa existência.</p>

                <h3>SEJA HIT-BRA</h3>
                <p>Venha fazer parte desse processo de aprendizagem e praticidade da HIT-BRA em sua vida pessoal e profissional, temos garantias de resultados espetaculares. Insistimos sempre em levar o conhecimento para a sua vida e para a construção de um mundo melhor.</p>

              </span>
              {/* {this.state.notShow ? null : (
                <div className="clear">
                  <div className="boxGraduations">
                    <h4>Certifications</h4>
                    <ul>
                      <li>I'm a title. Click here to add your own text and edit me.</li>
                      <li>I'm a title. Click here to add your own text and edit me.</li>
                      <li>I'm a title. Click here to add your own text and edit me.</li>
                    </ul>
                  </div>
                  <div className="boxGraduations">
                    <h4>Qualifications</h4>
                    <ul>
                      <li>I'm a title. Click here to add your own text and edit me.</li>
                      <li>I'm a title. Click here to add your own text and edit me.</li>
                      <li>I'm a title. Click here to add your own text and edit me.</li>
                    </ul>
                  </div>
                </div>
              )} */}
            </div>
          </article>
        </section>
        <div class="contact-simplefooter">
          <div className="footer-father">
            <Simplefooter />
          </div>
        </div>
      </div>
    )
  }

  componentDidMount () {
    window.scroll(0, 0)
  }
}



// WEBPACK FOOTER //
// ./src/components/aboutUs/aboutUs.js